export const gaEvent = (name) => {
    window.gtag('event', name, {});
}